export default {
   // 测试环境
  //  AppId: 'wx3fbf6f30ae7bb620',
  //  AppSecret: '6dde4474c550f152917739aeccb70ca9',
  //  Host: 'http://192.168.1.98:8081/',
  //  H5Host: 'https://h5.msloan.joylingame.com/'

  // //OSS环境 乐米
  // Host:'http://xiecard.joylingame.com:8083/',
  // AppId: 'wx33d3ed22c9d87d3c',
  // AppSecret: '7042cc426b2c60d10eb414af8aed35df'

  //OSS环境   http://xiecardh5.joylingame.com
  Host: "http://api.xieka.joylingame.com:8083/",
  AppId: "wx3fbf6f30ae7bb620",
  AppSecret: "6dde4474c550f152917739aeccb70ca9",
};
